import { useState } from "react";
import { Loader2, Mail } from "lucide-react";
import { toast } from "sonner";
import { api, errText } from "@/lib/auth";

const MAX = 1000;

// A longer love letter to a partner after a shared session. Once sent it is kept in both Sacred Boxes and cannot be changed.
export default function LoveNote({ code, partner, onSent, testId = "love-note" }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setBusy(true);
    try {
      await api.post(`/quantum/partner/${code}/love-note`, { text: text.trim() });
      setText("");
      toast.success(`Your love note to ${partner || "your partner"} is sealed in your Sacred Boxes.`);
      onSent?.();
    } catch (err) {
      toast.error(errText(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };
  return (
    <form data-testid={testId} onSubmit={send} className="border border-[#E8838E]/30 bg-[#140910] p-6">
      <p className="flex items-center gap-2 font-display text-2xl text-[#F2E8DF]"><Mail className="w-5 h-5 text-[#E8838E]" /> A love note{partner ? ` for ${partner}` : ""}</p>
      <p className="mt-2 text-[14px] text-[#A8998C]">Once sent, it stays as a keepsake in both your Sacred Boxes. It can’t be edited or removed.</p>
      <textarea data-testid={`${testId}-text`} value={text} onChange={(e) => setText(e.target.value.slice(0, MAX))} rows={6} maxLength={MAX} placeholder="What you felt, what you saw in them, what you wish to remember…" className="mt-4 w-full bg-[#0F070B] border border-[#D9B47A]/25 px-4 py-3 text-[16px] leading-relaxed text-[#F2E8DF] placeholder:text-[#8F8176] focus:outline-none focus:border-[#E8838E]" />
      <div className="mt-3 flex items-center justify-between gap-3">
        <span data-testid={`${testId}-count`} className="font-tt-mono text-[12px] text-[#A8998C]">{text.length} / {MAX}</span>
        <button data-testid={`${testId}-send`} disabled={busy || !text.trim()} className="inline-flex items-center gap-2 rounded-full bg-[#D9B47A] text-[#0A0706] px-5 py-3 font-tt-mono text-[12px] uppercase tracking-[0.2em] hover:bg-[#F2E8DF] transition-colors disabled:opacity-50">{busy && <Loader2 className="w-4 h-4 animate-spin" />} Seal and send</button>
      </div>
    </form>
  );
}
